module.exports = __webpack_public_path__ + "6cd144329db9197581f1ef7d72770e78.svg";